import * as React from 'react';

import type {NotifyMessage} from 'nutshell-core/types';

import {ListView} from '../list-view/list-view';

import {NotifyComplete} from './notify-complete';
import {NotifyProcessing} from './notify-processing';

import styles from './notifies-list.module.css';

type Props = {
    notifyMessages: NotifyMessage[];
    types: string;
    onAcknowledgeExport: (notify: NotifyMessage) => any;
    onAcknowledgeExportDownload: () => any;
};

export const NotifiesList = (props: Props) => {
    const {notifyMessages, types} = props;

    // Filename format `YYYYMMDD_HHMMSS_<type>_export.csv` from Nut\RestApi\ListExporter
    // is zero-padded, so lex-desc == chrono-desc. In-progress rows (no filename yet)
    // float to the top so active work is visible first.
    const sortedNotifyMessages = [...notifyMessages].sort((a, b) => {
        if (!a.filename && !b.filename) return 0;
        if (!a.filename) return -1;
        if (!b.filename) return 1;
        return b.filename.localeCompare(a.filename);
    });

    return (
        <div className={styles.list}>
            <ListView
                header={<div className={styles.header}>Your {types} (newest first)</div>}
                collection={sortedNotifyMessages}
                renderRow={(notify: NotifyMessage) => {
                    const {status, name} = notify;

                    return status === 'complete' ? (
                        <NotifyComplete
                            key={name}
                            notify={notify}
                            onAcknowledgeExport={props.onAcknowledgeExport}
                            onAcknowledgeExportDownload={props.onAcknowledgeExportDownload}
                        />
                    ) : (
                        <NotifyProcessing
                            key={name}
                            notify={notify}
                            onAcknowledgeExport={props.onAcknowledgeExport}
                        />
                    );
                }}
            />
        </div>
    );
};
